module.exports = __webpack_public_path__ + "static/media/itss-logo-catalogue.1d975b33.png";